import { useFormContext } from "react-hook-form";
import { Field, FieldGroup, FieldLabel, FieldSet } from "@/components/ui/field";
import { Input } from "@/components/ui/input";

export type NoticeFormPayload = {
  name: string;
  version: string;
};

export function NoticeForm() {
  const {
    register,
    formState: { errors },
  } = useFormContext<NoticeFormPayload>();

  return (
    <FieldGroup>
      <FieldSet>
        <FieldGroup>
          <Field>
            <FieldLabel htmlFor="checkout-7j9-card-name-43j">Name</FieldLabel>
            <Input
              placeholder="Notice Name"
              {...register("name", { required: true })}
            />
          </Field>

          <Field>
            <FieldLabel htmlFor="checkout-7j9-card-number-uw1">
              Version
            </FieldLabel>
            <Input
              placeholder="v1"
              {...register("version", { required: true })}
            />
          </Field>
        </FieldGroup>
      </FieldSet>
    </FieldGroup>
  );
}
